import { createContext, useContext } from 'react';
import type { StepColorMap } from 'types/stepRun';

export type StepRunColors = StepColorMap | null;

export const StepRunContext = createContext<StepRunColors>(null);

export const useStepRunColors = (): StepRunColors => useContext(StepRunContext);
